import { useMatch } from "react-router";

import { ASSISTANT_PAGE_PATH } from "../constants";

const useIsAssistantPageMode = () => !!useMatch(ASSISTANT_PAGE_PATH);

export default useIsAssistantPageMode;
